import { ORDER_SET_QUANTITY } from './actionTypes'

export default function orderSetQuantity(payload) {
  return {
    type: ORDER_SET_QUANTITY,
    payload,
  }
}
